"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Card.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    marko_attrs = require("marko/dist/runtime/vdom/helpers/attrs"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    marko_attrs0 = {
        "class": "card-content"
      };

function render(input, out, __component, component, state) {
  var data = input;

  out.be("div", {
      "class": marko_classValue(marko_classValue([
        "card",
        input.class
      ])),
      style: marko_styleValue(input.style)
    }, "0", component, null, 1);

  out.be("div", marko_attrs0, "1", component);

  if (input.header) {
    out.be("div", marko_assign({}, marko_attrs(input.header), {
        "class": "card-header"
      }), "2", component, null, 4);

    marko_dynamicTag(out, input.header.renderBody, null, null, null, null, __component, "3");

    out.ee();
  }

  if (input.body) {
    out.be("div", marko_assign({}, marko_attrs(input.body), {
        "class": "card-body pb-0"
      }), "4", component, null, 4);

    marko_dynamicTag(out, input.body.renderBody, null, null, null, null, __component, "5");

    out.ee();
  }

  if (input.footer) {
    out.be("div", marko_assign({}, marko_attrs(input.footer), {
        "class": "card-footer"
      }), "6", component, null, 4);

    marko_dynamicTag(out, input.footer.renderBody, null, null, null, null, __component, "7");

    out.ee();
  }

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
